// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1GxEj","img":"styles_img__2VRtN","back-btn":"styles_back-btn__2Bu9q","backBtn":"styles_back-btn__2Bu9q"};